import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Button } from '@this/shared/ui/inputs/button';
import { Textarea } from '@this/shared/ui/inputs/textarea/textarea';
import { useAITTheme } from '@this/shared/ui/theme';

import { getStyles } from './repository_display_adjustment.styles';

interface Props {
  banList: string;
  update: (banList: string) => Promise<void>;
}

const HotelBanListForm: React.FC<Props> = ({ banList, update }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const [value, setValue] = useState(banList);
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setValue(banList);
    setTouched(false);
  }, [banList]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    setTouched(true);
  }, []);

  const handleSubmit = useCallback(async () => {
    if (!window.confirm('本当によろしいですか？')) {
      return;
    }
    setSubmitting(true);
    try {
      await update(value);
      setTouched(false);
    } finally {
      setSubmitting(false);
    }
  }, [update, value]);

  return (
    <div style={styles.textareaForm}>
      <div style={styles.textareaLabel}>除外ワード（1行1件）</div>
      <Textarea rows={10} value={value} onChange={handleChange} fullWidth />
      <div style={styles.formActions}>
        <Button
          color="primary"
          style={styles.submitButton}
          onClick={handleSubmit}
          disabled={!touched || submitting}
        >
          更新
        </Button>
      </div>
    </div>
  );
};

export default HotelBanListForm;
